import { isValid } from 'date-fns'
import { DateTime } from 'luxon'
import { registerLocale } from 'react-datepicker'
import fi from 'date-fns/locale/fi'
import sv from 'date-fns/locale/sv'
import enGB from 'date-fns/locale/en-GB'
import nl from 'date-fns/locale/nl'

registerLocale('fi', fi)
registerLocale('sv', sv)
registerLocale('en', enGB)
registerLocale('nl', nl)

/** Locale configuration shared across date picker components. */
export const localeMap = {
  fi: {
    locale: fi,
    format: 'dd.MM.yyyy',
    placeholder: 'pp.kk.vvvv',
    blocks: [2, 2, 4],
    separator: '.',
    weekStartsOn: 1
  },
  sv: {
    locale: sv,
    format: 'yyyy-MM-dd',
    placeholder: 'yyyy-mm-dd',
    blocks: [4, 2, 2],
    separator: '-',
    weekStartsOn: 1
  },
  en: {
    locale: enGB,
    format: 'yyyy/MM/dd',
    placeholder: 'yyyy/mm/dd',
    blocks: [4, 2, 2],
    separator: '/',
    weekStartsOn: 1
  },
  nl: {
    locale: nl,
    format: 'dd-MM-yyyy',
    placeholder: 'dd-mm-jjjj',
    blocks: [2, 2, 4],
    separator: '-',
    weekStartsOn: 1
  }
}

/** Coerces an ISO string or JS Date to a valid JS Date, or null. */
export const toDate = (value) => {
  if (!value) return null
  if (value instanceof Date) return isValid(value) ? value : null
  const d = new Date(value)
  return isValid(d) ? d : null
}

/** Converts a JS Date to an ISO date string (yyyy-MM-dd), or null. */
export const toISO = (date) =>
  date && isValid(date) ? DateTime.fromJSDate(date).toISODate() : null
